import type { ReactNode } from "react";

type HermesEmptyStateProps = {
  icon: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
};

/** Estado vazio: ícone num círculo, título e a próxima ação. Nunca uma tabela cinza vazia. */
export const HermesEmptyState = ({
  icon,
  title,
  description,
  action,
}: HermesEmptyStateProps) => (
  <div className="animate-hermes-swap-in flex flex-col items-center gap-3 px-6 py-14 text-center">
    <span className="bg-hermes-muted text-hermes-muted-fg grid size-12 place-items-center rounded-full [&_svg]:size-5">
      {icon}
    </span>
    <p className="text-hermes-fg font-semibold">{title}</p>
    <p className="text-hermes-muted-fg max-w-[44ch] text-sm text-pretty">
      {description}
    </p>
    {action}
  </div>
);
